$(function () {
  window.Sharer.init();
});